// Layout.tsx
import { Box} from "@chakra-ui/react";
import FooterParent from "./FooterParent";



interface PublicLayoutProps {
  children: React.ReactNode;
}



const ParentLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  const onLogout = () => {};
  return (
    
    <Box>
      {/* <NavBar isAuthenticated={false} onLogout={onLogout} userInitials={null}  /> */}
      <Box as="main" minH="80vh"  mt="72px" >
        {children} {/* Page content goes here */}
      </Box>
      <FooterParent />
    </Box>
    
  );
};

export default ParentLayout;
